import React from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { isFreeEmailDomain } from '../../../../utils/utils';

interface RegisterFormProps {
    form: any;
    loading: boolean;
    emailDomains: string[] | [];
    onSubmit: (data: any) => void;
    onSwitchToLogin: () => void;
}

export const RegisterForm: React.FC<RegisterFormProps> = ({
    form,
    loading,
    emailDomains,
    onSubmit,
    onSwitchToLogin,
}) => {
    return (
        <Form form={form} layout="vertical" requiredMark={false} onFinish={onSubmit}>
            <h2>Please enter your info to continue</h2>

            <Row gutter={[8, 8]}>
                <Col span={12}>
                    <Form.Item
                        name="first_name"
                        label="First Name"
                        rules={[{ required: true, message: 'Field is required' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        name="last_name"
                        label="Last Name"
                        rules={[{ required: true, message: 'Field is required' }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item
                name="email"
                label="Email"
                rules={[
                    { required: true, message: 'Email is required' },
                    { type: 'email', message: 'Please input a valid email' },
                ]}
            >
                <Input type="email" />
            </Form.Item>

            <Form.Item shouldUpdate={(p, c) => p.email !== c.email} noStyle>
                {({ getFieldValue }) => {
                    const isFree = isFreeEmailDomain(getFieldValue('email'), emailDomains);

                    return (
                        <Form.Item
                            name="company"
                            label={isFree ? 'Company (Optional)' : 'Company'}
                            rules={[
                                {
                                    required: !isFree,
                                    message: 'Company is required',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    );
                }}
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit" block size="large" loading={loading}>
                    Continue to Quote
                </Button>
            </Form.Item>

            <p className="text-center mb-0">
                Already have an account?{' '}
                <Button type="link" onClick={onSwitchToLogin}>
                    Login
                </Button>
            </p>
        </Form>
    );
};
